import { useState } from "react";
import { Alert, Table } from "../../layout";
import { Avatar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Attendance = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });
  const handleView = (id) => {
    navigate(`/view_member_profile/${id}`);
  };

  return (
    <>
      <Table
        ActionComp={() => <></>}
        HeaderComp={() => <></>}
        tblHead={[
          { id: "member", label: t("Member") },
          { id: "id", label: t("Id") },
          { id: "contact", label: t("Contact") },
          { id: "visit", label: t("Visit") },
          { id: "package", label: t("Package") },
        ]}
        tblData={[
          {
            member: (
              <div className="d-flex mt-5 mb-5">
                <div className="mr-20">
                  <Avatar src={""} className="shadow-lg" />
                </div>
                <div className="d-grid">
                  <span
                    className="fw-5 primary-color c-pointer mb-3"
                    onClick={() => handleView(12)}
                  >
                    Jhon Smith
                  </span>
                  <span className="fs-12 fw-5 bg-success white-color pl-5 pr-5 pt-2 pb-2 w-fit br-8 tx-upp">
                    {t("Active")}
                  </span>
                </div>
              </div>
            ),
            id: (
              <div className="d-grid ">
                <span className="fs-15 fw-4 gray-color c-pointer">
                  {t("Thumb")}: 1234567
                </span>
                <span className="fs-15 fw-4 gray-color c-pointer">
                  {t("Member")}: 1234567
                </span>
              </div>
            ),
            contact: (
              <div className="d-grid ">
                <a
                  className="fs-14 primary-color c-pointer mb-3"
                  href={`mailto:johon@gmail.com`}
                >
                  ✉️ johon@gmail.com
                </a>
                <a
                  className="fs-14 primary-color c-pointer"
                  href={`tel:000000000`}
                >
                  📞 000000000
                </a>
              </div>
            ),
            visit: (
              <div className="d-grid ">
                <span className="fs-16 gray-color c-pointer mb-3">
                  Apr 11, 2023
                </span>
                <span className="fs-12 fw-4 gray-color c-pointer">
                  <span className="fw-5">{t("In")}:</span> 10:11:01 am |
                  <span className="fw-5">{t("Out")}:</span> 12:00:30 pm
                </span>
              </div>
            ),
            package: (
              <div className="d-grid ">
                <span className="fs-16 gray-color c-pointer mb-3">
                  Gym Regular - 12 Month
                </span>
                <span className="fs-12 fw-4 gray-color c-pointer">
                  <span className="fw-5">{t("Expire")}:</span> 10/02/2023
                </span>
              </div>
            ),
          },
          {
            member: (
              <div className="d-flex mt-5 mb-5">
                <div className="mr-20">
                  <Avatar src={""} className="shadow-lg" />
                </div>
                <div className="d-grid">
                  <span
                    className="fw-5 primary-color c-pointer mb-3"
                    onClick={() => handleView(12)}
                  >
                    Lary Padge
                  </span>
                  <span className="fs-12 fw-5 bg-error white-color pl-5 pr-5 pt-2 pb-2 w-fit br-8 tx-upp">
                    {t("Expired")}
                  </span>
                </div>
              </div>
            ),
            id: (
              <div className="d-grid ">
                <span className="fs-15 fw-4 gray-color c-pointer">
                  {t("Thumb")}: 1234567
                </span>
                <span className="fs-15 fw-4 gray-color c-pointer">
                  {t("Member")}: 1234567
                </span>
              </div>
            ),
            contact: (
              <div className="d-grid ">
                <a
                  className="fs-14 primary-color c-pointer mb-3"
                  href={`mailto:jihad@gmail.com`}
                >
                  ✉️ lary@gmail.com
                </a>
                <a
                  className="fs-14 primary-color c-pointer"
                  href={`tel:000000000`}
                >
                  📞 000000000
                </a>
              </div>
            ),
            visit: (
              <div className="d-grid ">
                <span className="fs-16 gray-color c-pointer mb-3">
                  Apr 11, 2023
                </span>
                <span className="fs-12 fw-4 gray-color c-pointer">
                  <span className="fw-5">In:</span> 10:11:01 am |{" "}
                  <span className="fw-5">Out:</span> 12:00:30 pm
                </span>
              </div>
            ),
            package: (
              <div className="d-grid ">
                <span className="fs-16 gray-color c-pointer mb-3">
                  Gym Regular - 12 Month
                </span>
                <span className="fs-12 fw-4 gray-color c-pointer">
                  <span className="fw-5">{t("Expire")}:</span> 10/02/2023
                </span>
              </div>
            ),
          },
          {
            member: (
              <div className="d-flex mt-5 mb-5">
                <div className="mr-20">
                  <Avatar src={""} className="shadow-lg" />
                </div>
                <div className="d-grid">
                  <span
                    className="fw-5 primary-color c-pointer mb-3"
                    onClick={() => handleView(12)}
                  >
                    Charly Frank
                  </span>
                  <span className="fs-12 fw-5 bg-success white-color pl-5 pr-5 pt-2 pb-2 w-fit br-8 tx-upp">
                    {t("Active")}
                  </span>
                </div>
              </div>
            ),
            id: (
              <div className="d-grid ">
                <span className="fs-15 fw-4 gray-color c-pointer">
                  {t("Thumb")}: 1234567
                </span>
                <span className="fs-15 fw-4 gray-color c-pointer">
                  {t("Member")}: 1234567
                </span>
              </div>
            ),
            contact: (
              <div className="d-grid ">
                <a
                  className="fs-14 primary-color c-pointer mb-3"
                  href={`mailto:jihad@gmail.com`}
                >
                  ✉️ charly@gmail.com
                </a>
                <a
                  className="fs-14 primary-color c-pointer"
                  href={`tel:000000000`}
                >
                  📞 000000000
                </a>
              </div>
            ),
            visit: (
              <div className="d-grid ">
                <span className="fs-16 gray-color c-pointer mb-3">
                  Apr 11, 2023
                </span>
                <span className="fs-12 fw-4 gray-color c-pointer">
                  <span className="fw-5">In:</span> 10:11:01 am |{" "}
                  <span className="fw-5">Out:</span> 12:00:30 pm
                </span>
              </div>
            ),
            package: (
              <div className="d-grid ">
                <span className="fs-16 gray-color c-pointer mb-3">
                  Gym Regular - 12 Month
                </span>
                <span className="fs-12 fw-4 gray-color c-pointer">
                  <span className="fw-5">Expire:</span> 10/02/2023
                </span>
              </div>
            ),
          },
        ]}
      />

      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default Attendance;
